<template>
  <v-app>
    <!-- <core-app-bar /> -->
    <core-drawer />
    <core-view />
    <v-tooltip right v-if="$vuetify.breakpoint.mdAndDown">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          left
          style="top:30px;left:-28px;"
          :elevation="5"
          absolute
          class="d-print-none"
          @click.stop="onClick"
          color="primary"
          fab
        >
          <v-icon>
            mdi-menu
          </v-icon>
        </v-btn>
      </template>
      Open Menu
    </v-tooltip>

    <v-offline @detected-condition="amIOnline" />
    <v-snackbar
      :value="!$store.state.isOnline"
      color="error"
      :timeout="-1"
      top
      right
    >
      <v-icon color="white" left>
        mdi-earth-off
      </v-icon>
      Vous n'êtes pas connecté, veuillez vérifier votre connexion internet!
    </v-snackbar>
    <error-handler />
  </v-app>
</template>

<script>
import ErrorHandler from "@/components/utils/ErrorHandler"
import VOffline from "v-offline"
export default {
  components: {
    VOffline,
    ErrorHandler,
    CoreDrawer: () => import("@/components/layouts/default/core/Drawer"),
    // CoreAppBar: () => import("@/components/layouts/default/core/AppBar"),
    CoreView: () => import("@/components/layouts/default/core/View")
  },
  data: () => ({
    onLine: true
  }),
  methods: {
    onClick() {
      this.$store.commit(
        "app/setMainDrawer",
        !this.$store.state.app.drawer.main
      )
    },
    amIOnline(e) {
      this.$store.commit(e ? "online" : "offline")
    }
  }
}
</script>
